<template>
  <div class="page-contact">
    <section class="page-contact__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">Klantenservice</h1>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <h2 class="form__title">Neem contact met ons op!</h2>

              <ContactForm confirmation-path="/contact-opnemen/bevestigd" />
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <h3 class="info__title">
              Ben je een consument en heb je een vraag?
            </h3>
            <p class="info__body">
              Vul het contactformulier in en wij nemen binnen 24 uur contact met
              je op. Ook als je verbeterpunten voor ons hebt, horen wij dat
              natuurlijk graag.
            </p>

            <h3 class="info__title">
              Ben je een professional en heb je interesse in het ontvangen van
              offerte-aanvragen?
            </h3>
            <p class="info__body">
              Wij verzorgen een constante stroom aan nieuwe klanten. Neem
              <nuxt-link class="text-primary" to="/contact-opnemen-bedrijf">
                hier
              </nuxt-link>
              contact met ons op. Vul het contactformulier in en wij nemen
              binnen 24 uur contact met je op.
            </p>
          </div>
        </div>
      </div>
    </section>

    <div
      class="page-contact__cross-sell"
      :style="{
        backgroundImage: `url('${require('chimera/all/assets/images/huisprojecten.jpg')}')`,
      }"
    >
      <div class="cross-sell container">
        <div class="cross-sell__wrapper">
          <h2 class="cross-sell__title">
            Bespaar ook op de kosten <br />van andere diensten
          </h2>

          <p class="cross-sell__body">
            Ga nu naar Huisprojecten.nl en vind gratis en vrijblijvend de beste
            deals van meer dan 2.000 geselecteerde professionals.
          </p>

          <t-btn-link
            id="linkToHuisprojecten"
            class="cross-sell__link"
            href="https://www.huisprojecten.nl"
            target="_blank"
          >
            Ga naar Huisprojecten.nl
          </t-btn-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from 'chimera/all/components/form/contact/ContactForm'
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  name: 'ContactPage',

  components: {
    ContactForm,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Neem contact met ons op',
      headDescription:
        'Je kunt contact opnemen met Kozijnenvergelijker.nl door het contactformulier in te vullen.',
      path: '/contact-opnemen',
    }
  },
}
</script>
